/* global __API_ROOT_URL__ */
import angular from 'angular';
import constants from 'app/constants';

require('ng-file-upload');

const ngFileUpload = 'ngFileUpload';


let _$http;
let _utilityService;

export class riskDataService {
  constructor(
    $http,
    Upload,
    utilityService // eslint-disable-line no-shadow
  ) {
    _$http = $http;
    _utilityService = utilityService;

    console.log('app.services.controlDataService created');
  }

  initRiskAdmin() {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerRiskAdministration/initCustomerRiskAdministration`,
      method: 'GET',
      params: {}
    });
  }

  init() {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerRiskAdministration/init`,
      method: 'GET',
      params: {}
    });
  }

  getRiskType(riskTypeId) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerRiskType/${riskTypeId}`,
      method: 'GET',
      // params: { includeControls: true }
    });
  }

  getRiskTypeByAssetType(riskTypeId, assetTypeId) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerRiskType/${riskTypeId}/byAssetType/${assetTypeId}`,
      method: 'GET',
      // params: { includeControls: true }
    });
  }

  getRisk(riskId) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerRisk/${riskId}`,
      method: 'GET',
      // params: { includeControls: true }
    });
  }

  getRiskById(riskId) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerRisk/editRiskData/${riskId}`,
      method: 'GET',
      // params: { includeControls: true }
    });
  }

  getRisks() {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerRisk`,
      method: 'GET',
      params: { includeControls: true }
    });
  }

  getRiskTypes() {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerRiskType`,
      method: 'GET',
      params: { includeControls: true }
    });
  }

  getRiskTypeDefaults() {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerRiskType/default`,
      method: 'GET',
    });
  }

  checkRiskTypeExists(id, name) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerRiskType/exists/`,
      method: 'GET',
      params: {
        id,
        name,
      },
    });
  }

  checkRiskNameExists(displayValue, customerRiskId) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerRisk/checkExists`,
      method: 'GET',
      params: {
        name: displayValue,
        id: customerRiskId,
      },
    });
  }

  getControlWeights() {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerControlTypeWeight`,
      method: 'GET',
    });
  }

  saveRiskType(risk) {
    let _url = `${__API_ROOT_URL__}/ent/customerRiskType`;
    let _method = 'POST';

    if (risk.customerRiskTypeId > 0) {
      _url = `${__API_ROOT_URL__}/ent/customerRiskType/${risk.customerRiskTypeId}`;
      _method = 'PUT';
    }

    return _$http({
      url: _url,
      method: _method,
      data: _utilityService.serializeData(risk),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  saveRisk(risk) {
    let _url = `${__API_ROOT_URL__}/ent/customerRisk`;
    let _method = 'POST';

    if (risk.customerRiskId > 0) {
      _url = `${__API_ROOT_URL__}/ent/customerRisk/${risk.customerRiskId}`;
      _method = 'PUT';
    }

    return _$http({
      url: _url,
      method: _method,
      data: JSON.stringify(risk),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/Json' },
    });
  }

  saveRiskControlTypes(assetTypeId, customerRiskTypeId, customerControlTypeIds) {
    // eslint-disable-next-line max-len
    const _url = `${__API_ROOT_URL__}/ent/customerAssetType/${assetTypeId}/risk/${customerRiskTypeId}/addControls`;
    // const _url = `${__API_ROOT_URL__}/ent/customerRiskTypeCustomerControlType/bulkSave/${customerRiskTypeId}`;
    const _method = 'PUT';

    return _$http({
      url: _url,
      method: _method,
      data: JSON.stringify(customerControlTypeIds),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/Json' },
    });
  }

  saveRiskControls(customerRiskId, customerControls) {
    const _url = `${__API_ROOT_URL__}/ent/customerRisk/${customerRiskId}/controls`;
    const _method = 'PUT';

    return _$http({
      url: _url,
      method: _method,
      data: JSON.stringify(customerControls),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/Json' },
    });
  }

  saveControlSettings(settings) {
    const _url = `${__API_ROOT_URL__}/ent/controlAdministrationSettings`;
    const _method = 'POST';

    // if (control.customerControlId > 0) {
    //   _url = `${__API_ROOT_URL__}/ent/customerControl/${control.customerControlId}`;
    //   _method = 'PUT';
    // }

    return _$http({
      url: _url,
      method: _method,
      data: JSON.stringify(settings),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/Json' },
    });
  }

  deleteRiskType(riskTypeId) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerRiskType/${riskTypeId}`,
      method: 'DELETE',
    });
  }

  deleteRisk(riskId) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerRisk/${riskId}`,
      method: 'DELETE',
    });
  }

  bulkDeleteRisks(idList) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerRisk/bulkDelete`,
      method: 'PUT',
      data: JSON.stringify(idList),
      params: { echo: true, },
      headers: { 'Content-Type': 'application/Json' },
    });
  }

  syncRisk(riskSyncDTO) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerRisk/syncToCustomerRiskType`,
      method: 'PUT',
      data: JSON.stringify(riskSyncDTO),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/Json' },
    });
  }
}

riskDataService.$inject = ['$http', 'Upload', 'utilityService'];
export default angular.module('app.services.riskDataService', [
  ngFileUpload,
  constants,
])
  .service('riskDataService', riskDataService)
  .name;
